import { MobileModal } from 'components/MobileModal';
import { MobileProfilesMenu } from 'containers/ProfileManager/components/MobileProfilesMenu';
import React from 'react';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';
import { OpcionMenuAdmin } from 'containers/MenuAvatar/components/OpcionMenuAdmin';

export const MenuAvatarMobile = ({ onClose }) => {
  const { profilesEnable } = useProfiles();

  return (
    <MobileModal onClose={onClose}>
      <div className="mobile-profiles-menu fade__in">
        {profilesEnable && <MobileProfilesMenu onClose={onClose} />}
        <OpcionMenuAdmin onClose={onClose} />
      </div>
    </MobileModal>
  );
};
